<template>
  <ModalContainer :show="show">
    <template slot="body">
      <div class="modal-content">
        <div class="d-flex align-items-center justify-content-end">
          <img
            src="../../assets/images/Vector (1).png"
            alt="close"
            class="cursor-pointer mt-1 mr-1"
            @click="$emit('close')"
          />
        </div>

        <div
          class="d-flex flex-column align-items-center justify-contents-center body"
        >
          <img
            src="../../assets/gif/32e2f3cf85639bd2fd912b5a4ef69bc3.gif"
            alt=""
            class="w-50"
            v-if="isExport"
          />
          <img
            src="../../assets/gif/193b03fa39e2db16ba333d43d58bc214.gif"
            alt=""
            class="w-50"
            v-else
          />

          <p
            class="mt-3 font-20 font-weight-bolder"
            style="text-transform: capitalize; text-align: center;"
          >
            {{ heading }}
          </p>

          <p class="gray4 font-14 text-center" :class="msgWidth">{{ msg }}.</p>

          <div
            class="mt-4 d-flex justify-contents-between align-items-center col-gap-2 w-100"
          >
            <button
              type="button"
              class="btn btn-primary w-100"
              @click="$emit('close')"
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    </template>
  </ModalContainer>
</template>

<script>
import ModalContainer from "../../components/ModalContainer";

export default {
  name: "SuccessModal",
  components: {
    ModalContainer,
  },
  props: {
    show: Boolean,
    heading: String,
    msg: String,
    isExport: Boolean,
    msgWidth: {
      type: String,
      default: 'msg_default',
    }
  },
};
</script>

<style scoped>
.modal-content {
  width: 100%
}
.body {
  padding: 50px;
}
@media (max-width: 575.98px) {
  .modal-content {
    width: 100% !important;
  }
  .body {
    padding: 25px;
  }
}
</style>
